import React from 'react';
import cc from 'classcat';
import styles from './CardNews.module.sass';
import { Anchor, Text } from '../Text';
// import { resolveUrl } from '../../utils/resolveUrl';
// import {ReworkUrl} from "../../utils/reworkUrl";
import { Image } from '../Image/Image';
import { resolveUrl } from '../../utils/resolveUrl';

export const CardNews = ({ array, size = 'sm', link, isMobile, isMedia }) => {
  const minutesEnd = minutes => {
    if (minutes % 10 === 1 && minutes % 100 !== 11) {
      return `${minutes} минута`;
    }
    if (
      [2, 3, 4].includes(minutes % 10) &&
      ![12, 13, 14].includes(minutes % 100)
    ) {
      return `${minutes} минуты`;
    }
    return `${minutes} минут`;
  };

  return (
    <div>
      <div
        itemScope
        itemType="http://schema.org/Article"
        className={cc([
          styles.card,
          {
            // [styles.small]: size === 'sm',
            // [styles.medium]: size === 'md',
            [styles.large]: size === 'xl',
          },
        ])}
      >
        <Anchor href={link || array?.link} className={styles.wrapper}>
          <div className={styles.linkPhoto}>
            <Image
              src={`${resolveUrl(array?.photo?.src || array?.photo)}`}
              srcSet={`${resolveUrl(array?.photo?.srcSet || array?.photo)}`}
              alt={String(array?.photo?.alt)}
              title={String(array?.photo?.title)}
              loading="lazy"
              itemProp="image"
            />
          </div>
          <div className={styles.content}>
            <div className={styles.info}>
              <Anchor
                variant="timeTable"
                weiht="700"
                href={`/blog?media=${array?.media.id}`}
                itemProp="publisher"
              >
                {array?.media?.label}
              </Anchor>
              <Text
                // className={styles.date}
                className={isMedia ? styles.mediaDate : styles.date}
                component="p"
                variant="text-1"
                itemProp="datePublished"
              >
                {array?.date}
              </Text>
              {!!array.reading_time && (
                <div className={styles.readTime} itemProp="timeRequired">
                  <Text component="div" variant="text-1" color="subColor">
                    {minutesEnd(array.reading_time)}
                  </Text>
                </div>
              )}
            </div>
            <div className={styles.description}>
              <Text
                component="h2"
                variant={size === 'xl' && !isMobile ? 'heading-2' : 'heading-6'}
                itemProp="headline"
                topGap={16}
                bottomGap={12}
              >
                {array?.title}
              </Text>
              <Text
                className={styles.text}
                component="p"
                variant="text-1"
                itemProp="description"
              >
                {array?.description}
              </Text>
            </div>
          </div>
        </Anchor>
      </div>
    </div>
  );
};
